'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertCircle } from '@subframe/core';
import { Button, Dialog } from '@/shared/components/ui';
interface ErroModalProps {
  titulo: string;
  descricao: string;
  onTentarNovamente: () => void;
}
export const ErroModal = t0 => {
  const $ = _c(13);
  const {
    titulo,
    descricao,
    onTentarNovamente
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-error-50 text-error-600 flex h-14 w-14 items-center justify-center rounded-full text-2xl"><FeatherAlertCircle /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== titulo) {
    t2 = <h1 className="text-heading-dark text-2xl font-semibold">{titulo}</h1>;
    $[1] = titulo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== descricao) {
    t3 = <p className="text-label-muted text-sm leading-relaxed">{descricao}</p>;
    $[3] = descricao;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-col items-center gap-2 text-center">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onTentarNovamente) {
    t5 = <Button className="w-full" onClick={onTentarNovamente}>Tentar novamente</Button>;
    $[8] = onTentarNovamente;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Dialog open={true} onOpenChange={_temp}><Dialog.Content className="w-[calc(100%-2rem)] max-w-[440px] items-center gap-6 rounded-[16px] px-6 py-8 sm:px-9 sm:py-10">{t1}{t4}{t5}</Dialog.Content></Dialog>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp() {}